import React from 'react';
import { Modal } from 'antd';
import { useFormContext } from 'react-hook-form';
import { AlertSuccess } from '../../../../util/Alert';
import { useQueryClient } from '@tanstack/react-query';
import fitQuizServices from '../../../../../services/fit-quiz.services';
import LegacyQuizCategoryForm from '../form/LegacyQuizCategoryForm';

const LegacyQuizCategoryModal = ({ open, handleClose }) => {
  const { watch, handleSubmit } = useFormContext();
  const queryClient = useQueryClient();

  const { mutate: createLegacyQuizCategory } =
    fitQuizServices.useMutationCreateLegacyQuizCategory(() => {
      queryClient.invalidateQueries({
        queryKey: ['get-legacy-quiz-category'],
        refetchType: 'all',
      });
      AlertSuccess('เพิ่มข้อมูลสำเร็จ');
      handleClose();
    });

  const { mutate: editLegacyQuizCategory } =
    fitQuizServices.useMutationUpdateLegacyQuizCategory(() => {
      queryClient.invalidateQueries({
        queryKey: ['get-legacy-quiz-category'],
        refetchType: 'all',
      });
      AlertSuccess('แก้ไขข้อมูลสำเร็จ');
      handleClose();
    });

  const _HandleSubmit = handleSubmit((data) => {
    const legayQuizCategoryData = {
      imageUrl: data.imageUrl,
      title: data.title,
      display: data.display,
    };

    if (watch('formType') === 'create') {
      createLegacyQuizCategory(legayQuizCategoryData);
    } else if (watch('formType') === 'edit') {
      editLegacyQuizCategory({ id: data.id, data: legayQuizCategoryData });
    }
  });

  return (
    <Modal
      title={
        watch('formType') === 'create'
          ? 'เพิ่มหมวดหมู่ชุดคำถาม'
          : 'แก้ไขหมวดหมู่ชุดคำถาม'
      }
      visible={open}
      onCancel={handleClose}
      okText="บันทึก"
      cancelText="ยกเลิก"
      onOk={_HandleSubmit}
      width={'50vw'}
    >
      <LegacyQuizCategoryForm />
    </Modal>
  );
};

export default LegacyQuizCategoryModal;
